import { addYears } from 'date-fns';
import { sortBy, values } from 'ramda';
import { createSelector } from 'reselect';

import { getBillingDataRoot } from './billingData.selectors';

const getGifts = createSelector(getBillingDataRoot, (state) => state.sentGifts);
const sortPurchasedGiftsByCreatedDate = createSelector(getGifts, (list) => sortBy(({ created }) => created, values(list)));
const getGiftByKey = createSelector(
    getGifts,
    (_, key: string) => key,
    (gifts, key) => gifts[key]
);
const getNonActivatedGifts = createSelector(sortPurchasedGiftsByCreatedDate, (gifts) => gifts.filter((gift) => gift.isGifted === false));
const getNonActivatedNonExpiredGifts = createSelector(sortPurchasedGiftsByCreatedDate, (gifts) =>
    gifts.filter((gift) => {
        const expires = gift.expires || addYears(gift.created, 2).valueOf();
        return !gift.isGifted && expires > Date.now();
    })
);
const getLastPurchasedGiftById = createSelector(
    (_, giftId: string) => giftId,
    sortPurchasedGiftsByCreatedDate,
    (giftId, gifts) => gifts.find((gift) => gift.id === giftId)
);

export const BillingDataSentGiftsSelectors = {
    sortPurchasedGiftsByCreatedDate,
    getGiftByKey,
    getNonActivatedGifts,
    getNonActivatedNonExpiredGifts,
    getLastPurchasedGiftById,
} as const;
